export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const COLORED_LOGO = "https://customer-assets.emergentagent.com/job_15cab680-befd-4974-8675-ac0323fde202/artifacts/nhiz70qf_North%20Somerset%20Enviroment%20-%20Logo.png";

export const ROLES = [
  { value: 'admin', label: 'Admin' },
  { value: 'hr_admin', label: 'HR Admin' },
  { value: 'website_admin', label: 'Website Admin' },
  { value: 'director', label: 'Director' },
  { value: 'manager', label: 'Manager' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'employee', label: 'Employee' },
];

export const ALL_PERMISSIONS = [
  { key: 'users', label: 'User Management' },
  { key: 'departments', label: 'Departments' },
  { key: 'jobs', label: 'Job Listings' },
  { key: 'applications', label: 'Applications' },
  { key: 'holidays', label: 'Holiday Admin' },
  { key: 'announcements', label: 'Announcements' },
  { key: 'documents', label: 'HR Documents' },
  { key: 'requests', label: 'Employee Requests' },
  { key: 'website', label: 'Website CMS' },
  { key: 'services', label: 'Services Management' },
  { key: 'about', label: 'About Page' },
  { key: 'footer_docs', label: 'Footer Documents' },
  { key: 'permissions', label: 'Permissions' },
  { key: 'csv_backup', label: 'CSV Backup' },
  { key: 'intranet_holidays', label: 'Intranet: Holidays' },
  { key: 'intranet_expenses', label: 'Intranet: Expenses' },
  { key: 'intranet_queries', label: 'Intranet: Queries' },
  { key: 'intranet_directory', label: 'Intranet: Staff Directory' },
  { key: 'intranet_announcements', label: 'Intranet: Announcements' },
  { key: 'intranet_documents', label: 'Intranet: HR Documents' },
];
